/**
 * An accessor function to safely get the global window object, in a way that can be mocked in tests.
 * @returns The global window object, or `undefined` when `window` is not available (e.g. during SSR).
 */
export const getWindow = (): Window | undefined =>
  typeof window === 'undefined' ? undefined : window;
